import { type GroupsClientInterface } from './groupsClient.types';
import CorporateGroupsClient from './corporateGroupsClient';
import OrgUnitGroupsClient from './orgUnitGroupsClient';
import type { ClientContext } from '~/services/contextClient';

export default class GroupsClientFactory {
    static createClient(context: Omit<ClientContext, 'groupId'>): GroupsClientInterface {
        if (!context.orgUnitId) {
            return new CorporateGroupsClient(context.teamId);
        }

        return new OrgUnitGroupsClient(context.teamId, context.orgUnitId);
    }
}
